import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";

// ── ค่าธรรมเนียม Escrow ───────────────────────────────────────────────────
// ราคา < ฿1,000 → ฿50 คงที่
// ราคา ≥ ฿1,000 → ฿100 คงที่
// หมายเหตุ: ใช้แสดงผล/พรีวิวในหน้าจอเท่านั้น ตัวเลขจริงคำนวณซ้ำฝั่ง server ใน
// functions/escrow.js เสมอ ห้ามไว้ใจค่าที่คำนวณจากฝั่งนี้เป็นตัวตัดสิน
export function calcFee(price) {
  if (price < 1000) return 50;
  return 100;
}

// ── คำนวณค่าธรรมเนียมหลังใช้คูปอง ────────────────────────────────────────
// คืน { originalFee, discount, finalFee }
export function calcDiscountedFee(price, coupon = null) {
  const originalFee = calcFee(price);
  if (!coupon) return { originalFee, discount: 0, finalFee: originalFee };

  let discount = 0;
  if (coupon.type === "percent") {
    discount = Math.round(originalFee * coupon.value / 100);
    if (coupon.maxDiscount) discount = Math.min(discount, coupon.maxDiscount);
  } else {
    // flat — ลดเป็นบาทตรงๆ
    discount = Math.min(coupon.value, originalFee);
  }

  const finalFee = Math.max(0, originalFee - discount);
  return { originalFee, discount, finalFee };
}

// ── ตรวจสอบและดึงคูปองจาก Firestore ─────────────────────────────────────
// ใช้พรีวิวส่วนลดในหน้าจอก่อนกดจ่ายเงินเท่านั้น — escrowLock ตรวจคูปองซ้ำฝั่ง server
// คืน coupon object ถ้าใช้ได้ หรือ throw Error พร้อมข้อความ
export async function validateCoupon(code, uid, price) {
  const q = query(
    collection(db, "coupons"),
    where("code", "==", code.trim().toUpperCase())
  );
  const snap = await getDocs(q);
  if (snap.empty) throw new Error("ไม่พบรหัสคูปองนี้");

  const couponDoc = snap.docs[0];
  const c = { id: couponDoc.id, ...couponDoc.data() };

  if (!c.isActive)                       throw new Error("คูปองนี้ถูกปิดใช้งานแล้ว");
  if (c.expiresAt && c.expiresAt.toDate() < new Date())
                                         throw new Error("คูปองหมดอายุแล้ว");
  if (c.maxUses && c.usedCount >= c.maxUses)
                                         throw new Error("คูปองถูกใช้ครบจำนวนแล้ว");
  if (c.minPrice && price < c.minPrice)  throw new Error(`ใช้ได้เมื่อราคาสินค้าไม่ต่ำกว่า ฿${c.minPrice.toLocaleString()}`);
  if (c.usedBy?.includes(uid))           throw new Error("คุณเคยใช้คูปองนี้แล้ว");
  if (c.ownerId && c.ownerId === uid)    throw new Error("ใช้คูปองของตัวเองไม่ได้");

  return c;
}

// ── ดึงข้อมูล Wallet ──────────────────────────────────────────────────────
export async function getWallet(uid) {
  const snap = await getDoc(doc(db, "users", uid));
  if (!snap.exists()) return { wallet_balance: 0, locked_balance: 0 };
  return snap.data();
}

// ── การเคลื่อนเงินทั้งหมด — ย้ายไปเป็น Cloud Functions แล้ว ────────────────
// escrow ล็อก/ปล่อย/คืนเงิน:      functions/escrow.js    (escrowLock/Release/Refund)
// เติมเงิน/ถอนเงิน:                functions/walletOps.js (topupApprove/Reject, withdrawRequest/Approve/Reject)
// เรียกผ่าน httpsCallable ใน ChatPage.js / WalletPage.js / AdminPage.js เท่านั้น
// ห้ามเขียนยอด wallet_balance / locked_balance ตรงๆ จาก client อีก
